<div>
    <img class="img-responsive" src={{image}} *ngIf="image">
    <p *ngIf="!image" class="noImageP">{{title}}</p>
    <p *ngIf="image">{{title}}</p>
    <div class='infoButton' *ngIf='standings' (click)="showStandings($event)">Info</div>
</div>
